<nav class="pgn-container"
     *ngIf="total > 0"
     [attr.aria-label]="ariaLabel">

  <!-- IZQUIERDA: selector de tamaño de página -->
  <div class="pgn-size-group">
    <label [attr.for]="'pgn-size-' + uniqueId">Mostrar</label>
    <select
      class="form-control pgn-size-select"
      [id]="'pgn-size-' + uniqueId"
      [value]="pageSize"
      [disabled]="disabled"
      (change)="onPageSizeChange($event)"
      aria-label="Items por página">
      <!-- <option *ngFor="let opt of pageSizeOptions" [value]="opt">{{ opt }}</option> -->
      <option *ngFor="let opt of pageSizeOptions" [value]="opt" [selected]="opt === pageSize">{{ opt }}</option>
    </select>
  </div>

  <!-- DERECHA: resumen "Mostrando X–Y de Z" + controles de página -->
  <div class="pgn-right">
    <span class="pgn-summary">
      Mostrando {{ firstItemIndex }}&ndash;{{ lastItemIndex }} de {{ total }}
    </span>

    <ng-container *ngIf="totalPages > 1">
      <span class="pgn-sep" aria-hidden="true">·</span>

      <div class="pgn-controls" role="group">
        <!-- Botón "anterior" -->
        <button
          type="button"
          class="pgn-btn pgn-nav"
          [disabled]="disabled || page <= 1"
          (click)="goTo(page - 1)"
          aria-label="Página anterior">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M15 6l-6 6 6 6"
                  stroke="currentColor" stroke-width="2"
                  fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <!-- Listado de páginas (números + elipsis) -->
        <ng-container *ngFor="let entry of pages; trackBy: trackByEntry">
          <span *ngIf="isEllipsis(entry)"
                class="pgn-ellipsis"
                aria-hidden="true">…</span>

          <button *ngIf="!isEllipsis(entry)"
                  type="button"
                  class="pgn-btn"
                  [class.is-current]="entry === page"
                  [disabled]="disabled || entry === page"
                  [attr.aria-current]="entry === page ? 'page' : null"
                  [attr.aria-label]="'Ir a página ' + entry"
                  (click)="goTo(toNumber(entry))">
            {{ entry }}
          </button>
        </ng-container>

        <!-- Botón "siguiente" -->
        <button
          type="button"
          class="pgn-btn pgn-nav"
          [disabled]="disabled || page >= totalPages"
          (click)="goTo(page + 1)"
          aria-label="Página siguiente">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M9 6l6 6-6 6"
                  stroke="currentColor" stroke-width="2"
                  fill="none" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    </ng-container>
  </div>
</nav>